import { summarize } from "./data";

const getChanges = (data, groupingKey, fromYear, toYear) => {
  const limits = data.reduce((result, datum) => {
    const key = datum[groupingKey];

    result[key] = result[key] || {};

    switch (datum.year) {
      case fromYear:
        result[key].lower = datum.value;

        break;

      case toYear:
        result[key].upper = datum.value;

        break;

      default:
        break;
    }

    return result;
  }, {});

  return Object.keys(limits)
    .map(key => {
      const lower = limits[key].lower;
      const upper = limits[key].upper;

      return {
        [groupingKey]: key,
        absoluteChange: upper - lower,
        proportionalChange: (upper - lower) / lower
      };
    })
    .flatMap(datum => [
      {
        [groupingKey]: datum[groupingKey],
        year: `# (${fromYear}-${toYear})`,
        value: datum.absoluteChange
      },
      {
        [groupingKey]: datum[groupingKey],
        year: `% (${fromYear}-${toYear})`,
        value: datum.proportionalChange
      }
    ]);
};

export const getChangeData = (data, groupBy) => {
  let summary = summarize(
    data.filter(
      datum => datum.year === 2020 || datum.year === 2025 || datum.year === 2030
    ),
    [groupBy, "year"]
  ).map(datum => ({
    ...datum,
    year: datum.year.toString()
  }));

  const totals = summarize(summary, ["year"]).map(datum => ({
    ...datum,
    [groupBy]: "Total"
  }));

  summary = [...summary, ...totals];

  const changes = [
    ...getChanges(summary, groupBy, "2020", "2025"),
    ...getChanges(summary, groupBy, "2025", "2030"),
    ...getChanges(summary, groupBy, "2020", "2030")
  ];

  return [...summary, ...changes];
};
